export const functionalGroupCodes = (
  { inCartFunctionalGroups, inCartTemplates },
  { templateId },
) => {
  const template = inCartTemplates.byId[templateId];
  return inCartFunctionalGroups.byId[template.functionalGroupId]
    .functionalGroupCodes;
};
